export class ErplGlossary {
	glossaryContainer;
	glossaryItems = [];
	offsetTop = 0;
	constructor(glossaryContainer) {
		this.glossaryContainer = glossaryContainer;
		this.glossaryItems = Array.from(this.glossaryContainer.querySelectorAll('a[href^="#"]'));

		this.offsetTop = $('nav.erpl_header-menu').height() || 0 ;

		this.init()
	}

	init(){


		if (this.glossaryContainer.dataset.scrollSpy) {

		 	this.glossaryItems.forEach(glossaryItem => {
				let relatedElement = document.querySelector(glossaryItem.hash);

				if (relatedElement) {

					let offsetTop = parseFloat(glossaryItem.dataset.scrollOffset) || this.offsetTop;
					let observer = new IntersectionObserver((entries) => {			

						for (const entry of entries) {
							if (entry.isIntersecting) {
								this.spy(glossaryItem.hash)
							}
						}

					}, { rootMargin: `-${offsetTop}px 0px -${(window.innerHeight - 10 - offsetTop)}px 0px`})


					observer.observe(relatedElement)
				}

			})
		}
		

	
	}

	spy(hash = location.hash){
		this.glossaryItems.forEach(el => {
			el.parentElement.classList.remove('checked');
			el.removeAttribute('aria-current')
		});

		if (hash) {

			let relatedGlossaryItem = this.glossaryItems.find(el => el.hash === hash);

			relatedGlossaryItem.parentElement.classList.add('checked');

			relatedGlossaryItem.setAttribute('aria-current', 'true')

		}
	}


}